export const galleryData = {
  "minesweeper-no-guess": [
    {
      type: "image",
      src: require("../assets/gallery/minesweeper/Screenshot 2026-03-21 at 12.21.15.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/minesweeper/Screenshot 2026-03-21 at 12.21.18.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/minesweeper/Screenshot 2026-03-21 at 12.21.46.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/minesweeper/Screenshot 2026-03-21 at 12.22.07.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/minesweeper/Screenshot 2026-03-21 at 12.22.14.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/minesweeper/Screenshot 2026-03-21 at 12.22.21.png"),
    },
  ],
  masterPortfolio: [
    {
      type: "image",
      src: require("../assets/gallery/portfolio/Screenshot 2026-03-21 at 12.22.59.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/portfolio/Screenshot 2026-03-21 at 12.23.06.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/portfolio/Screenshot 2026-03-21 at 12.23.12.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/portfolio/Screenshot 2026-03-21 at 12.23.20.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/portfolio/Screenshot 2026-03-21 at 12.23.31.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/portfolio/Screenshot 2026-03-21 at 12.23.38.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/portfolio/Screenshot 2026-03-21 at 12.23.47.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/portfolio/Screenshot 2026-03-21 at 12.23.57.png"),
    },
  ],
  pdftrix: [
    {
      type: "image",
      src: require("../assets/gallery/pdftrix/Screenshot 2026-03-13 at 04.16.21.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/pdftrix/Screenshot 2026-03-13 at 04.16.52.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/pdftrix/Screenshot 2026-03-13 at 04.17.00.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/pdftrix/Screenshot 2026-03-13 at 04.17.35.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/pdftrix/Screenshot 2026-03-13 at 04.17.56.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/pdftrix/Screenshot 2026-03-13 at 04.19.48.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/pdftrix/Screenshot 2026-03-13 at 04.20.09.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/pdftrix/Screenshot 2026-03-13 at 04.20.27.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/pdftrix/Screenshot 2026-03-13 at 04.20.45.png"),
    },
  ],
  sa7etna: [
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.52.20.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.52.32.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.52.37.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.52.40.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.52.53.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.55.51.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.01.18.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.03.16.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.03.27.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.03.34.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.03.36.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.03.42.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.03.49.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.06.48.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.07.04.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.07.14.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.07.18.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.07.34.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.07.38.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.07.51.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.07.56.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.08.07.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.08.24.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.08.29.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.08.51.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.08.54.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.09.05.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.09.16.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.09.22.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.09.28.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.09.36.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.09.40.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.09.52.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.09.59.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.06.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.09.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.19.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.26.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.30.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.40.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.45.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.48.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.51.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.10.55.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.11.33.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.12.26.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sa7etna/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.12.39.png"),
    },
  ],
  "samem-ecommerce": [
    {
      type: "image",
      src: require("../assets/gallery/samem/Screenshot 2026-03-13 at 04.36.25.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/samem/Screenshot 2026-03-13 at 04.36.32.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/samem/Screenshot 2026-03-13 at 04.36.40.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/samem/Screenshot 2026-03-13 at 04.36.48.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/samem/Screenshot 2026-03-13 at 04.37.15.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/samem/Screenshot 2026-03-13 at 04.37.21.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/samem/Screenshot 2026-03-13 at 04.37.27.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/samem/Screenshot 2026-03-13 at 04.37.54.png"),
    },
  ],
  commercina: [
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.51.10.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.51.26.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.51.57.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.52.11.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.52.20.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.52.30.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.52.35.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.52.45.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.52.53.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.53.06.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.53.15.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.53.26.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/commercina/Screenshot 2026-08-24 at 14.53.33.png"),
    },
  ],
  "ai-commerce-platform": [
    {
      type: "image",
      src: require("../assets/gallery/ai-commerce/52bb1440-75e6-4c5e-8394-bd0dfa0d91b9.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/ai-commerce/742ce529-db2e-4652-a763-57d4dd025b60.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/ai-commerce/776549b3-1d37-47ae-90fc-e88f7e05a299.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/ai-commerce/7f12bdd2-7c86-4f1a-b591-d5490d269718.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/ai-commerce/808a25e4-a465-4de6-8c70-37e7f5607f78.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/ai-commerce/ac4b0f01-a5b1-4cb1-ad2a-51fa40085356.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/ai-commerce/c1e27035-2b32-446d-9be0-ac517cf29e62.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/ai-commerce/cc9f94e1-e874-40aa-acfb-25b472524a41.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/ai-commerce/d2246193-2078-4bef-9e21-c1d73554de42.jpeg"),
    },
  ],
  "crypto-pay-gateway": [
    {
      type: "image",
      src: require("../assets/gallery/crypto-pay/crypto-pay-home.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/crypto-pay/crypto-pay-amount.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/crypto-pay/crypto-pay-confirm.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/crypto-pay/crypto-pay-final-step.png"),
    },
  ],
  "fit-pro": [
    {
      type: "image",
      src: require("../assets/gallery/fit-pro/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.46.24.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/fit-pro/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.47.14.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/fit-pro/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.47.21.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/fit-pro/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.47.29.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/fit-pro/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.47.56.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/fit-pro/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.48.03.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/fit-pro/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.48.06.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/fit-pro/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 07.48.45.png"),
    },
  ],
  bacSport: [
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.32.29.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.32.36.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.36.51.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.36.59.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.37.07.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.37.16.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.37.21.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.37.29.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.37.38.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.37.41.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.37.52.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.38.06.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.38.11.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.38.18.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/bacsport/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.38.50.png"),
    },
  ],
  "chess-telegram": [
    {
      type: "video",
      src: require("../assets/gallery/chess_telegram/chess_telegram.mp4"),
    },
    {
      type: "image",
      src: require("../assets/gallery/chess_telegram/Screenshot 2026-03-13 at 04.32.45.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/chess_telegram/Screenshot 2026-03-13 at 04.32.58.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/chess_telegram/Screenshot 2026-03-13 at 04.33.38.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/chess_telegram/Screenshot 2026-03-13 at 04.33.40.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/chess_telegram/Screenshot 2026-03-13 at 04.33.45.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/chess_telegram/Screenshot 2026-03-13 at 04.33.51.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/chess_telegram/Screenshot 2026-03-13 at 04.34.27.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/chess_telegram/Screenshot 2026-03-13 at 04.34.37.png"),
    },
  ],
  findHouse: [
    { type: "image", src: require("../assets/gallery/findhouse/img-099.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-102.png") },
    { type: "image", src: require("../assets/gallery/findhouse/img-104.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-106.png") },
    { type: "image", src: require("../assets/gallery/findhouse/img-107.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-109.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-111.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-112.png") },
    { type: "image", src: require("../assets/gallery/findhouse/img-114.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-116.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-117.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-119.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-121.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-122.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-124.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-126.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-127.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-129.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-130.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-132.jpg") },
    { type: "image", src: require("../assets/gallery/findhouse/img-133.jpg") },
  ],
  "flow-web3": [
    {
      type: "image",
      src: require("../assets/gallery/flow/13200120-8c49-4ac5-9a4f-45c773d67bad.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/flow/2b2ca206-0945-4496-aa33-0291df649474.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/flow/643bc00e-aac6-4339-9e41-f80a80150d9a.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/flow/9295812d-b9c9-421e-82cc-50cb0bc74fba.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/flow/9d8e7957-f3a9-4d74-80d0-f5a3107577c3.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/flow/b87f211b-7121-40bd-b05a-c665b2ff01f7.jpeg"),
    },
  ],
  libyaBuy: [
    {
      type: "image",
      src: require("../assets/gallery/libyaBuy/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.42.01.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/libyaBuy/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.42.09.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/libyaBuy/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.42.15.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/libyaBuy/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.42.21.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/libyaBuy/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.42.28.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/libyaBuy/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.42.31.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/libyaBuy/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.42.34.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/libyaBuy/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.42.37.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/libyaBuy/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.42.53.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/libyaBuy/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.43.14.png"),
    },
  ],
  "oracle-nlq": [
    {
      type: "image",
      src: require("../assets/gallery/sql_generator/Screenshot 2026-03-13 at 04.42.06.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sql_generator/Screenshot 2026-03-13 at 04.44.51.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sql_generator/Screenshot 2026-03-16 at 09.14.00.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sql_generator/Screenshot 2026-03-16 at 09.14.28.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sql_generator/Screenshot 2026-03-16 at 09.14.41.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/sql_generator/Screenshot 2026-03-16 at 09.15.30.png"),
    },
  ],
  trucksApp: [
    {
      type: "image",
      src: require("../assets/gallery/TrucksApp/14c6f1fa-6d85-42fa-b1d5-7b90424f523f.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/TrucksApp/5a271a88-c4b4-49a4-aa2a-f22923f9c754.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/TrucksApp/67d9872c-cef5-4d68-a686-5b102351541f.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/TrucksApp/8f4048b3-bba1-41f1-8c24-1a423065df24.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/TrucksApp/90a04872-6ea1-4140-a631-e1e7a8adfe03.jpeg"),
    },
    {
      type: "video",
      src: require("../assets/gallery/TrucksApp/98c04bdc-d5af-48da-8678-2179dc363257.mp4"),
    },
    {
      type: "video",
      src: require("../assets/gallery/TrucksApp/c3bcd90e-ec66-4373-8965-bb09c268c09c.mp4"),
    },
    {
      type: "image",
      src: require("../assets/gallery/TrucksApp/ea1c1375-8cb4-4710-84b3-50ad3d2c8d25.jpeg"),
    },
    {
      type: "image",
      src: require("../assets/gallery/TrucksApp/f9e33d8f-e541-4a01-8326-140f16071ecf.jpeg"),
    },
  ],
  ts1: [
    {
      type: "image",
      src: require("../assets/gallery/ts1/Screenshot 2026-03-13 at 03.56.31.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/ts1/Screenshot 2026-03-13 at 03.56.44.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/ts1/Screenshot 2026-03-13 at 04.04.34.png"),
    },
  ],
  "glasses-vto": [
    {
      type: "image",
      src: require("../assets/gallery/glasses-vto/bc93897a-1abb-4e87-829f-ff0fcf993781.jpeg"),
    },
  ],
  "za3ma-game": [
    {
      type: "video",
      src: require("../assets/gallery/za3ma/Simulator Screen Recording - iPhone 17 Pro - 2026-03-17 at 08.27.01.mov"),
    },
    {
      type: "image",
      src: require("../assets/gallery/za3ma/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.20.37.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/za3ma/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.20.50.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/za3ma/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.21.48.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/za3ma/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.22.22.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/za3ma/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.22.31.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/za3ma/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.22.35.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/za3ma/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.22.39.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/za3ma/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.27.27.png"),
    },
    {
      type: "image",
      src: require("../assets/gallery/za3ma/Simulator Screenshot - iPhone 17 Pro - 2026-03-17 at 08.27.31.png"),
    },
  ],
  "ai-student-concentration-tracker": [
    { type: "image", src: require("../assets/gallery/educo/img-021.png") },
    { type: "image", src: require("../assets/gallery/educo/img-023.jpg") },
    { type: "image", src: require("../assets/gallery/educo/img-025.png") },
  ],
};
